/** @jsx jsx */

import { jsx } from '@emotion/core';

import { LogoImage } from '@zapier/common-components';
import { Colors } from '@zapier/design-system';

import { trialExtensionReasons } from '@zapier/design-system-revenue/src/types';

const imageCss = (type: string) => {
  const dimensions = {
    [trialExtensionReasons.emailSupport]: {
      height: '100%',
    },
    [trialExtensionReasons.multistep]: {
      height: '125%',
    },
    [trialExtensionReasons.paths]: {
      height: '75%',
    },
    [trialExtensionReasons.premium]: {
      height: '120%',
      left: '60%',
    },
    [trialExtensionReasons.premiumLimit]: {
      height: '120%',
      left: '60%',
    },
    [trialExtensionReasons.taskLimit]: {
      height: '60%',
    },
    [trialExtensionReasons.zapLimit]: {
      height: '150%',
    },
  };

  return {
    position: 'absolute',
    left: '65%',
    ...dimensions[type],
  };
};

const imageContainerCss = {
  width: 150,
  height: 150,
  backgroundColor: Colors.white,
  boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.1)',
  border: `1px solid ${Colors.grey200}`,
  borderRadius: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

type Props = {
  appName?: string;
  type: string;
};

const imageMap = {
  [trialExtensionReasons.emailSupport]: 'upgrade-nudge-email-support',
  [trialExtensionReasons.multistep]: 'upgrade-nudge-multistep',
  [trialExtensionReasons.paths]: 'upgrade-nudge-paths',
  [trialExtensionReasons.premium]: 'upgrade-nudge-apps',
  [trialExtensionReasons.premiumLimit]: 'upgrade-nudge-apps',
  [trialExtensionReasons.taskLimit]: 'upgrade-nudge-task-limit',
  [trialExtensionReasons.taskLimit80Percent]:
    'upgrade-nudge-task-limit-80-percent',
  [trialExtensionReasons.zapLimit]: 'upgrade-nudge-zaps',
};

export const NudgeImage = ({ type, appName }: Props) => {
  const fileName = imageMap[type];
  let ImageSvg;

  try {
    ImageSvg = require(`./images/${fileName}.svg`).default;
  } catch {
    ImageSvg = null;
  }

  return appName ? (
    <div css={imageContainerCss}>
      {ImageSvg && <ImageSvg css={imageCss(type)} />}
      <LogoImage app={appName} />
    </div>
  ) : ImageSvg ? (
    <ImageSvg css={imageCss(type)} />
  ) : null;
};
